export * from "./MainBannerSlogans";
export * from "./MainBannerSlogans.types";
